import { Step } from 'react-joyride';

import { TERRITORIES_TOUR_CLASSES } from './classNames';

export const territoriesSteps: Step[] = [
  {
    target: `.${TERRITORIES_TOUR_CLASSES.PAGE_HEADER}`,
    title: 'Welcome to Territories',
    content:
      'This is your territory explorer where you can discover, explore, and manage available franchise territories.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.MAP_CONTAINER}`,
    title: 'Interactive Territory Map',
    content:
      'Explore territories visually on this interactive map. You can zoom, pan, and click on territories to see details.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.MAP_EXPAND_BUTTON}`,
    title: 'Expand Map View',
    content:
      'Click this button to expand the map for a better view. Try clicking it now!',
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.SEARCH_INPUT}`,
    title: 'Search Territories',
    content:
      'Use this search to filter territories by state name or zip code. Try searching for a state!',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.BY_STATE_CONTAINER}`,
    title: 'Territories by State',
    content:
      'Browse territories organized by state. Each state shows the total, sold, and reserved territory counts.',
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.STATE_VIEW_BUTTON}`,
    title: 'View State Territories',
    content:
      'Click "View" to expand a state and see all its territories. Try expanding a state now!',
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.TERRITORY_ITEM_ROW}`,
    title: 'Individual Territories',
    content:
      'Each territory shows its ID, zip codes, and current status. You can expand territories for more details.',
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.TERRITORY_EXPAND_BUTTON}`,
    title: 'Territory Details',
    content:
      'Click this button to see detailed demographics and territory information.',
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.TERRITORY_DEMOGRAPHIC_SECTION}`,
    title: 'Demographic Section',
    content:
      'This is the demographic section of the territory detail view. It shows the demographic information of the territory.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.TERRITORY_LIKE_BUTTON}`,
    title: 'Like Territories',
    content:
      "Found a territory you're interested in? Click the heart to like it and track it in your preferences.",
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${TERRITORIES_TOUR_CLASSES.TERRITORY_RESERVE_BUTTON}`,
    title: 'Reserve Territory',
    content:
      'Ready to move forward? Reserve a territory to show serious interest and begin the next steps.',
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
];
